const humanFileSize = (stringSize) => {
  const base = 1000;
  const size = typeof stringSize === 'string' ? parseInt(stringSize, 10) : stringSize;
  const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(base));
  const suffix = ["B", "KB", "MB", "GB"][i];
  const integer = Math.round(size / Math.pow(base, i));
  return integer + " " + suffix;
};
const toInteger = (value) => parseInt(value, 10);

const fileSizeToBytes = (humanFileSize) => {
  const base = 1000;
  let fileSizeString = humanFileSize.trim();
  let fileSizeBytes = null;

  if (/MB$/i.test(fileSizeString)) {
    fileSizeString = fileSizeString.replace(/MB$i/, "").trim();
    fileSizeBytes = toInteger(fileSizeString) * base * base;
  } else if (/KB$/i.test(fileSizeString)) {
    fileSizeString = fileSizeString.replace(/KB$i/, "").trim();
    fileSizeBytes = toInteger(fileSizeString) * base;
  } else {
    fileSizeBytes = toInteger(fileSizeString);
  }

  return fileSizeBytes;
};

const addFile = ({ newFile, existingFiles}) => {
  if (!existingFiles.find(file => file.name === newFile.name && file.size === newFile.size && file.lastModified === newFile.lastModified)) {
    existingFiles.push(newFile);
  }
}

export {
  humanFileSize,
  toInteger,
  fileSizeToBytes,
  addFile
}
